import { Hotel } from '@/payload-types'

const hotelTitle = (hotelTitle: string, hotelType: Hotel['hotelType'] | null) => {
  if (!hotelType) {
    return hotelTitle
  }

  switch (hotelType) {
    case 'partner':
      return `${hotelTitle} First Partner`
    case 'byFirst':
      return `${hotelTitle} by First`
    case 'signature':
      return `${hotelTitle} First Signature Collection`
    case 'first':
      return `${hotelTitle}`
    default:
      return hotelTitle
  }
}

export default hotelTitle
